import Modal from "common/Modal/Modal";
import Text from "common/Typography/Text";
import Link from "common/Typography/Link";
import Button from "common/Buttons/Button";
import React, { useContext, useEffect } from "react";
import useConnectTelegram from "features/onboarding/methodSettings/signalsGroup/connectExternalAccount/useConnectTelegram";
import { AnalyticsContext } from "analytics/AnalyticsProvider";
import { useIsOnboarding } from "utils/hooks/misc";
import { OnboardingStep } from "analytics/events";
import { OnboardingStyles } from "features/onboarding/common/styles";
import { extractTelegramUsernameFromLink } from "@shared/utils/misc";
import { LanguageNameSpaces, Platform } from "@shared/types";
import { sharedLib } from "@shared/services/shared.service";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";

interface GetUuidModalProps {
  isVisible: boolean;
  onCancel: () => void;
  botUrl?: string;
}

const GetUuidModal = ({ isVisible, onCancel, botUrl }: GetUuidModalProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.ONBOARDING);
  const { analytics } = useContext(AnalyticsContext);
  const { data: uuidDeeplink } =
    sharedLib.sharedApi.authentication.useGetUuidDeeplinkQuery({
      platform: Platform.WEBSITE,
    });
  const userBotUsername = extractTelegramUsernameFromLink(botUrl);
  const { setLocalStorageKey } = useConnectTelegram();
  const isOnboarding = useIsOnboarding();

  useEffect(() => {
    if (isVisible) {
      setLocalStorageKey();
    }
  }, [isVisible]);

  const onClickButton = () => {
    analytics?.telegramUuidSent({
      onboardingStep: isOnboarding ? OnboardingStep.METHOD_SETTINGS : undefined,
    });
    window.open(uuidDeeplink, "_blank");
    onCancel();
  };

  return (
    <Modal
      open={isVisible}
      onCancel={onCancel}
      width={450}
      title={false}
      footer={false}
      styles={{
        body: {
          padding: 32,
          textAlign: "center",
        },
      }}
    >
      <OnboardingStyles.ModalTitle style={{ marginBottom: 16 }}>
        {t("external_account.get_uuid_modal.title")}
      </OnboardingStyles.ModalTitle>
      <Text as="div" style={{ textAlign: "center" }}>
        {t("external_account.get_uuid_modal.description")}{" "}
        <Link href={botUrl} target="_blank" style={{ fontSize: "inherit" }}>
          @{userBotUsername}
        </Link>
      </Text>
      {uuidDeeplink && (
        <Button
          type="primary"
          style={{ marginTop: 24, height: 40, width: "100%" }}
          onClick={onClickButton}
        >
          {t("external_account.get_uuid_modal.button")}
        </Button>
      )}
    </Modal>
  );
};

export default GetUuidModal;
